import Profile from "../components/profile/profile.component"

const UserProfile = () => {
  return (
    <Profile />
  )
}

export default UserProfile;